
import {KTCard} from '../../../../../_metronic/helpers'
import { UserEditModal } from './chat-edit-modal/UserEditModal'
import { ChatListHeader } from './components/header/UsersListHeader'
import { ChatListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ChatsTable } from './table/UsersTable'

const ChatList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ChatListHeader />
        <ChatsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <UserEditModal />}
    </>
  )
}

const ChatListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ChatListViewProvider>
        <ChatList />
      </ChatListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ChatListWrapper}
